import { useMemo } from 'react';
import jwtDecode from 'jwt-decode';

export const useSelectJWTExaminationId = (token: string | undefined) => {
  return useMemo(
    () =>
      token
        ? jwtDecode<{ examinationId: number }>(token)?.examinationId
        : undefined,
    [token],
  );
};

export const useSelectJWTVisitId = (token: string | undefined) => {
  return useMemo(
    () => (token ? jwtDecode<{ visitId: number }>(token)?.visitId : undefined),
    [token],
  );
};
